import { Component, inject } from '@angular/core'
import { SystemConfigService } from '@account/Services/SystemConfigService'

@Component({
	selector: 'index-component',
	templateUrl: './Index.Component.html',
})
export class IndexComponent {
	public systemConfigService: SystemConfigService

	constructor() {
		this.systemConfigService = inject(SystemConfigService)
	}
}
